module.exports = __webpack_public_path__ + "files/fd31d730dfa2b5d8e33a8c6d2947ee37.svg";